import React, { type FC } from 'react'

import { useRecoilCallback, useRecoilValue } from 'recoil'

import { ModalConfirm } from 'mailup-web-components'

import {
  modalRecipientTrackingCancelCallback,
  modalRecipientTrackingConfirmCallback,
} from 'Pages/RecipientsList/recoil/callbacks/modalRecipientTracking'
import { modalRecipientTrackingState } from 'Pages/RecipientsList/recoil/state/modalRecipientTracking'
import { useIntl } from 'react-intl'

const ModalRecipientTracking: FC = () => {
  const intl = useIntl()

  const { show, tracking } = useRecoilValue(modalRecipientTrackingState)

  const handleCancel = useRecoilCallback(
    modalRecipientTrackingCancelCallback,
    [],
  )

  const handleConfirm = useRecoilCallback(
    modalRecipientTrackingConfirmCallback,
    [],
  )

  const modalTrackingVariant = tracking ? 'delete' : null

  const modalTrackingTitle = tracking
    ? 'Load.ActiveRecipientSummary.StopTrackingModalTitle'
    : 'Load.ActiveRecipientSummary.EnableTrackingModalTitle'

  const modalTrackingMsg = tracking
    ? 'Load.ActiveRecipientSummary.StopTrackingModalDescr'
    : 'Load.ActiveRecipientSummary.EnableTrackingModalDescr'

  const modalTrackingConfirmLabel = tracking
    ? 'Load.ActiveRecipientSummary.StopTracking'
    : 'Load.ActiveRecipientSummary.EnableTracking'

  return (
    <ModalConfirm
      show={show}
      title={intl.formatMessage({
        id: modalTrackingTitle,
      })}
      message={intl.formatMessage({
        id: modalTrackingMsg,
      })}
      stringConfirm={intl.formatMessage({
        id: modalTrackingConfirmLabel,
      })}
      stringCancel={intl.formatMessage({ id: 'Load.MailupCommon.Cancel' })}
      onClickConfirm={handleConfirm}
      onClickCancel={handleCancel}
      variant={modalTrackingVariant}
    />
  )
}

export default ModalRecipientTracking
